import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Info,
  Save,
  ClipboardCheck,
  Clock3,
  ShieldCheck,
  ChevronRight,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import "./HomebuyerDossierIntro.css";

export default function HomebuyerDossierIntro() {
  const navigate = useNavigate();
  const { t } = useTranslation("dossierIntro");

  return (
    <div className="hb-dossier-intro">
      <div className="hb-dossier-intro__shell">
        <div className="hb-dossier-intro__topbar">
          <div className="hb-dossier-intro__pill">
            <Info size={16} strokeWidth={2} />
            <span>{t("topbar.officialStep")}</span>
          </div>

          <div className="hb-dossier-intro__pill">
            <Save size={16} strokeWidth={2} />
            <span>{t("topbar.autosave")}</span>
          </div>
        </div>

        <div className="hb-dossier-intro__hero">
          <h1 className="hb-dossier-intro__title">{t("title")}</h1>

          <p className="hb-dossier-intro__subtitle">{t("subtitle")}</p>
        </div>

        <div className="hb-dossier-intro__cards">
          <div className="hb-dossier-intro__card">
            <div className="hb-dossier-intro__card-header">
              <span className="hb-dossier-intro__icon-wrap">
                <ClipboardCheck size={18} strokeWidth={2} />
              </span>
              <h2>{t("cards.whatYouDo.title")}</h2>
            </div>

            <p>{t("cards.whatYouDo.description")}</p>

            <ul>
              <li>{t("cards.whatYouDo.items.0")}</li>
              <li>{t("cards.whatYouDo.items.1")}</li>
              <li>{t("cards.whatYouDo.items.2")}</li>
              <li>{t("cards.whatYouDo.items.3")}</li>
            </ul>
          </div>

          <div className="hb-dossier-intro__card">
            <div className="hb-dossier-intro__card-header">
              <span className="hb-dossier-intro__icon-wrap">
                <Clock3 size={18} strokeWidth={2} />
              </span>
              <h2>{t("cards.goodToKnow.title")}</h2>
            </div>

            <ul className="hb-dossier-intro__simple-list">
              <li>{t("cards.goodToKnow.items.0")}</li>
              <li>{t("cards.goodToKnow.items.1")}</li>
              <li>{t("cards.goodToKnow.items.2")}</li>
              <li>{t("cards.goodToKnow.items.3")}</li>
            </ul>
          </div>
        </div>

        <div className="hb-dossier-intro__disclaimer">
          <div className="hb-dossier-intro__disclaimer-head">
            <span className="hb-dossier-intro__icon-wrap">
              <ShieldCheck size={18} strokeWidth={2} />
            </span>

            <div>
              <strong>{t("disclaimer.title")}</strong>{" "}
              <span>{t("disclaimer.headline")}</span>
            </div>
          </div>

          <p>{t("disclaimer.text")}</p>
        </div>

        <div className="hb-dossier-intro__footer">
          <div className="hb-dossier-intro__footer-text">
            <p>{t("footer.review")}</p>
            <p>{t("footer.next")}</p>
          </div>

          <button
            type="button"
            className="hb-dossier-intro__cta"
            onClick={() => navigate("/hb/dossier/form/personal-info")}
          >
            <span>{t("footer.apply")}</span>
            <ChevronRight size={18} strokeWidth={2.4} />
          </button>
        </div>
      </div>
    </div>
  );
}
